<template>
  <div>
    <PCNavbar id="pc-navbar" class="hidden-xs-only none_992" />
    <MobileNavBar class="hidden-md-and-up" />

    <TitleComponent class="hidden-xs-only none_992" />
    <TitleComponentMobile class="hidden-md-and-up" />
    <UserCaseMain ref="userCaseMain" class="hidden-xs-only none_992" />
    <UserCaseMainMobile class="hidden-md-and-up" />
    <CallMe class="hidden-xs-only none_992" />
    <MobileCallme class="hidden-md-and-up" />
  </div>
</template>

<script>
import PCNavbar from "@/components/navbar/index";
import MobileNavBar from "@/components/navbar/MobileNavBar.vue";
import CarouselHome from "@/components/carousel_home/index";
import TodoShow from "@/components/todo_show/index";
import MainTop from "@/components/main_top/index";
import UserCaseMain from "@/components/user_case_main/index";
import UserCaseMainMobile from "@/components/user_case_main_mobile/index";
import TitleComponent from "@/components/titleComponent/index";
import TitleComponentMobile from "@/components/titleComponentMobile/index";
import CallMe from "@/components/callme/index";

import MobileCallme from "@/components/callme/callMeMile.vue";
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    CarouselHome,
    UserCaseMain,
    CallMe,
    MainTop,
    TitleComponent,
    MobileCallme,
    UserCaseMainMobile,
    TitleComponentMobile,
  },
  data() {
    return {
      key: 0, // 用于强制刷新组件
    };
  },

  mounted() {
    this.key = this.key + 1;
  },
  watch: {
    // 监听 URL 的变化
    "$route.fullPath": {
      immediate: true,
      handler() {
        if (this.key !== 0) {
          this.$nextTick(() => {
            // 只在宽度大于 992px（与样式中断点一致）时滚动
            if (window.innerWidth <= 992) return;

            const comp = this.$refs.userCaseMain;
            const el = comp && comp.$el ? comp.$el : comp;
            if (!el) return;

            // 尝试获取 PC 导航栏高度作为偏移（如果有）
            const navbar = document.getElementById("pc-navbar");
            const navHeight = navbar ? navbar.offsetHeight : 0;

            const top =
              el.getBoundingClientRect().top + window.pageYOffset - navHeight - 100;
            window.scrollTo({ top, behavior: "smooth" });
          });
        }
        // 页面路由变化时，如果是桌面视图，滚动到 UserCaseMain 组件位置
      },
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.bottom_circle {
  width: 100%;
  text-align: center;
  padding-top: 100px;
  background-image: url(../assets/img/smalldot.png),
    url(../assets/img/smalldot1.png);
  background-position: 0 0, 110% 150%;
  background-repeat: no-repeat;
  background-size: 400px;

  h1 {
    font-size: 40px;
    padding-bottom: 20px;

    @media screen and (max-width: 992px) {
      font-size: 1.15rem;
      width: 60%;
      margin: 0 auto;
    }
  }

  .circle_img {
    width: 100%;

    img {
      width: 70%;

      @media screen and (max-width: 992px) {
        width: 100%;
        margin: 20px 0;
      }
    }
  }
}
</style>
